import { render, staticRenderFns } from "./BaseDetailGate.vue?vue&type=template&id=5ead72de&scoped=true"
import script from "./BaseDetailGate.vue?vue&type=script&lang=js"
export * from "./BaseDetailGate.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailGate.vue?vue&type=style&index=0&id=5ead72de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead72de",
  null
  
)

export default component.exports